import { RetiredComponent } from './components/retired/retired.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import * as comps from './components';
import { AuthGuard } from '@acepteam/globalspack';
import { ChapterLobbyDataResolve, MemberAppResolve, MemberAppUIDataResolve } from './resolves';
import { MembershipTypeGuard, ChaptersGuard } from './guards';

const resolveData: any = {
	uidata: MemberAppUIDataResolve,
	myaccountdata: MemberAppResolve,
}
const routes: Routes = [

	{
		path: 'personal',
		component: comps.PersonalInfoComponent,
		canActivate: [AuthGuard],
		resolve: resolveData
	},


	{
		path: 'membership',
		component: comps.MembershipComponent,
		canActivate: [AuthGuard],
		resolve: resolveData
	},
	{
		path: 'education',
		component: comps.EducationComponent,
		canActivate: [AuthGuard, MembershipTypeGuard],
		resolve: resolveData
	},
	{
		path: 'sections',
		component: comps.SectionsComponent,
		canActivate: [AuthGuard],
		resolve: resolveData
	},
	{
		path: 'chapters',
		component: comps.ChaptersComponent,
		canActivate: [AuthGuard, ChaptersGuard],
		resolve: resolveData
	},
	{
		path: 'changeaddress',
		component: comps.ChangeAddressComponent,
		canActivate: [AuthGuard],
		resolve: resolveData
	},
	{
		path: 'checkout',
		component: comps.CheckoutComponent,
		canActivate: [AuthGuard],
		resolve: resolveData
	},
	{
		path: 'retired',
		component: comps.RetiredComponent,
		canActivate: [AuthGuard],
		resolve: resolveData
	},
	{
		path: 'sectionapp',
		component: comps.SectionsComponent,
		canActivate: [AuthGuard],
		resolve: resolveData
	},
	{
		path: 'chapterlobby',
		component: comps.ChapterLobbyComponent,
		// canActivate: [AuthGuard],
		resolve: {
			lobbyData: ChapterLobbyDataResolve,
		}
	},
	{
		path: 'notify',
		component: comps.NotifyComponent,
		canActivate: [AuthGuard],
		resolve: resolveData
	},
	{
		path: 'notifysectionapp',
		component: comps.NotifyComponent,
		canActivate: [AuthGuard],
		resolve: resolveData
	},
	{
		path: '',
		redirectTo: 'personal',
		pathMatch: 'full'
	},
	{
		path: '**',
		redirectTo: 'personal',
		pathMatch: 'full'
	}


];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class MemberappRoutingModule { }
